export function authHeader() {
  let user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { 'X-Access-Token': user.token };
  } else {
    return {};
  }
}

export function authToken() {
  let user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return user.token;
  } else {
    return '';
  }
}
